import { SET_ACTIVE_MENU_ITEM, SET_MENU, SET_NEXT_ACTIVE_MENU_ITEM, SET_PREV_ACTIVE_MENU_ITEM } from "../../actionTypes/actionsTypes";
import { LocalAction } from "../../types";
import MenuItem from "../../../types/menu/MenuItem";
import MenuState from "../../../types/menu/MenuState";

export const initialMenuItem: MenuItem = {
  id: 0,
  name: 'NotFound',
  complete: false
}

const initialState: MenuState = {
  activeItem: initialMenuItem,
  nextActiveItem: initialMenuItem,
  prevActiveItem: initialMenuItem,
  activeItemStartedAt: Date.now(),
  hasUserNavigated: false,
  menu: [],
}

function getMenuReducer(state = initialState, action: LocalAction) {
  switch (action.type) {
    case SET_MENU:
      return {
        ...state,
        menu: action.data
      }
    case SET_ACTIVE_MENU_ITEM:
      return {
        ...state,
        activeItem: action.data,
        nextActiveItem: initialMenuItem,
        prevActiveItem: initialMenuItem,
        activeItemStartedAt: Date.now(),
        hasUserNavigated: true
      }
    case SET_NEXT_ACTIVE_MENU_ITEM:

      return {
        ...state,
        nextActiveItem: action.data,
      }
    case SET_PREV_ACTIVE_MENU_ITEM:
      return {
        ...state,
        prevActiveItem: action.data
      }
    default:
      return state;
  }
}

export default getMenuReducer;
